<template>
	<div class="basic-container">
		<section class="board-detail-area">
			<div class="sub-title">
				<h4 class="board">{{ apiData.contentTitle }}</h4>
			</div>
			<div class="board-header">
				<div class="col-header">등록일</div>
				<div class="col-contents">{{ $moment(apiData.regDate).format('YY-MM-DD') }}</div>
				<div class="col-header">작성자</div>
				<div class="col-contents">{{ 'OKTA마케팅지원팀' }}</div>
			</div>
			<div class="board-header end-line">
				<div class="col-header">첨부파일</div>
				<div class="col-contents max col-file">
					<a v-for="item in boardFiles" v-bind:key="item" :href="CONST.API_SERVER + '/okta/file/' + item.split('|')[0]" :external-url="true">
						<div><img class="icon-file" :src="require('../../assets/images/icon/icon-file@2x.png')" /> {{ item.split('|')[1] }}</div>
						<br
					/></a>
				</div>
			</div>
			<div class="board-contents" v-html="$options.filters.newLine(apiData.contentBody)">{{ listPage }}</div>
			<div class="board-header">
				<div class="col-header">이전글</div>
				<div class="col-contents max">
					<nav-link :url="'/board/' + type + '/' + apiData.prevBoardIdx"> {{ apiData.prevContentTitle }}</nav-link>
				</div>
			</div>
			<div class="board-header end-line">
				<div class="col-header">다음글</div>
				<div class="col-contents max">
					<nav-link :url="'/board/' + type + '/' + apiData.nextBoardIdx"> {{ apiData.nextContentTitle }}</nav-link>
				</div>
			</div>
		</section>
		<div class="btn-area mb-2">
			<button class="lineBtn" @click="goList">목록보기</button>
		</div>
	</div>
</template>

<script>
import CONST from '@/constants';
import imgPin from '../../assets/images/icon/icon-pin@2x.png';
import imgFile from '../../assets/images/icon/icon-file@2x.png';

export default {
	title: '게시판 상세',
	name: 'BoardDetail',
	props: ['type', 'idx', 'listPage'],
	data: function() {
		return {
			imgPin,
			imgFile,
			CONST,
			select: 1,
			apiData: [],
			boardFiles: [],
			loginMember: null,
		};
	},
	watch: {
		// type: function() {
		// 	this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, this.type === 'notice' ? 'HOME_NOTICE' : 'HOME_PDS');
		// },
		idx: function() {
			if (this.idx < 1) {
				alert('글이 없습니다.');
				return false;
			}
			this.getBoardDetail();
		},
	},
	beforeCreate() {},
	created() {},
	mounted() {
		let dt = this.$device.loadLocalData('LOGIN_USER');
		if (dt) this.loginMember = JSON.parse(dt);
		// this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, this.type === 'notice' ? 'HOME_NOTICE' : 'HOME_PDS');
		this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'COMMUNITY');
		this.getBoardDetail();
	},
	methods: {
		goList: function() {
			this.$device.pushView('/board/notice');
		},
		getBoardDetail: function() {
			let formData = new FormData();
			formData.append('boardType', this.type);
			formData.append('boardIdx', this.idx);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/board/getBoardDetail.do', formData)
				.then(res => {
					if (res.data.resultCode !== 0) {
						window.alert(res.data.resultMsg);
						this.$device.pushView('/board/' + this.type);
					} else {
						this.apiData = res.data.data;
						if (this.apiData.boardFile != null && this.apiData.boardFile !== '') {
							this.boardFiles = this.apiData.boardFile.split(',');
						} else {
							this.boardFiles = [];
						}
					}
				})
				.catch(e => {
					console.error(e);
					window.alert(e.message);
				});
		},
	},
};
</script>

<style scoped></style>
